// extracted by mini-css-extract-plugin
export var sectionContainer = "alternateImg-module--section-container--68c23";